<template>
    <div class="rangeInput">
        <div class="rangeInput-slider" v-bind:class="{ 'no--paddingLeftSide': noPaddingLeftSide }">
            <vue-slider
              v-bind="options"
              :min="0"
              :max="100"
              :step="0.5"
              :interval="stepValue"
              ref="slider"
              @callback="rangeInputChanged">
              <template slot="tooltip" slot-scope="tooltip">
                  <div class="tooltip">
                      <span>{{ currentValueDisplay }} {{ unit }}</span>
                  </div>
              </template>
            </vue-slider>
        </div>
        <input class="input" v-on:input="textInputChanged" v-model="currentValue" :min="minValue" :max="maxValue" :step="stepValue" type="number" />
        <div class="input-type">{{ unit }}</div>
    </div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  name: 'InputRange',
  props: ['type', 'setter', 'noPaddingLeftSide'],
  components: {
    vueSlider
  },
  data: function () {
    return {
      minPosition: 0,
      maxPosition: 400,
      dragged: false,
      typed: false,
      currentValue: 0,
      options: {
        width: '100%',
        height: 6,
        dotSize: 22,
        disabled: false,
        show: true,
        tooltip: 'always',
        tooltipDir: ['bottom', 'top'],
        piecewise: false,
        style: {
          paddingLeft: '0px',
          marginBottom: '30px'
        },
        bgStyle: {
          backgroundColor: '#E6ECF3'
        },
        sliderStyle: {
          backgroundColor: '#FFDA00',
          boxShadow: 'none'
        },
        tooltipStyle: {
          backgroundColor: '#111',
          borderColor: '#111',
          fontWeight: 'bold'
        },
        processStyle: {
          backgroundColor: '#FFDA00'
        }
      }
    }
  },
  computed: {
    unit: {
      get () {
        return this.$store.getters.getUnitType(this.type)
      }
    },
    minValue: {
      get () {
        return this.$store.getters.getInputMin(this.type)
      }
    },
    maxValue: {
      get () {
        return this.$store.getters.getInputMax(this.type)
      }
    },
    stepValue: {
      get () {
        return this.$store.getters.getInputStep(this.type)
      }
    },
    currentValueDisplay: {
      get () {
        if (this.currentValue > 10000) {
          return this.currentValue.toLocaleString('nl')
        }
        return this.currentValue
      }
    }
  },
  mounted: function () {
    // Trigger nextTick so we actually re-render the slider
    this.$nextTick(() => {
      this.currentValue = this.$store.state.variables[this.type]
      if (this.currentValue !== 0) {
        this.calculatePosition(this.currentValue)
      }
    })
  },
  methods: {
    rangeInputChanged: function (value) {
      if (this.typed === false) {
        this.calculateValue(value)
      }
    },
    textInputChanged: function (evt) {
      this.calculatePosition(evt.target.value)
    },
    calculatePosition: function (currentValue) {
      this.currentPosition = this.currentValue
      this.typed = true
      this.$refs.slider.setValue(this.currentPosition)
      this.$store.commit(this.setter, currentValue)
      this.typed = false
    },
    calculateValue: function (currentPosition) {
      if (currentPosition !== 0) {
        this.currentValue = currentPosition
        this.$store.commit(this.setter, this.currentValue)
      } else {
        this.currentValue = 0
        this.$store.commit(this.setter, parseInt(0, 10))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/helpers/range-input-steps.vue